

import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found.component';
import { CanActivateViaOAuthGuard } from './oAuth.canActivateGuard';
import { AdminCanActivateGuard } from './shared/guards/admin-can-activate.guard';

// Define which component should be loaded based on the current URL
export const routes: Routes = [

  { path: 'login', component: LoginComponent },
  { path: 'login/admin', component: LoginComponent },
  { path: '', redirectTo: 'login', pathMatch:"full" },
  { path: '**', component: PageNotFoundComponent }
];

// Export routes
export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: true });